import React, { Component } from 'react'
import {
  Col, Input, Tabs, List, Avatar, Button, Skeleton,
} from 'antd'

import reqwest from 'reqwest'

import {
  Vrcomponents,
  VrHeadercomponents,
  VrRowcomponents,
  VrTextcomponents,
  VrSearchcomponents,
} from './styled-components/vrStyled'

const { Search } = Input
const { TabPane } = Tabs

function callback(key) {
  console.log(key)
}

const count = 3
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`

class ProfileContainer extends Component {
  state = {
    initLoading: true,
    loading: false,
    data: [],
    list: [],
  };

  componentDidMount() {
    this.getData((res) => {
      this.setState({
        initLoading: false,
        data: res.results,
        list: res.results,
      })
    })
  }

  getData = (callback) => {
    reqwest({
      url: fakeDataUrl,
      type: 'json',
      method: 'get',
      contentType: 'application/json',
      success: (res) => {
        callback(res)
      },
    })
  };

  onLoadMore = () => {
    this.setState({
      loading: true,
      list: this.state.data.concat([...new Array(count)].map(() => ({ loading: true, name: {} }))),
    })
    this.getData((res) => {
      const data = this.state.data.concat(res.results)
      this.setState(
        {
          data,
          list: data,
          loading: false,
        },
        () => {
          // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
          // In real scene, you can using public method of react-virtualized:
          // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
          window.dispatchEvent(new Event('resize'))
        },
      )
    })
  };

  render() {
    const { initLoading, loading, list } = this.state
    const loadMore = !initLoading && !loading ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
        }}
      >
        <Button onClick={this.onLoadMore}>See more...</Button>
      </div>
    ) : null
    return (
      <Vrcomponents>
        <VrHeadercomponents>
          <Col>
            <VrRowcomponents>
              <Col>
                <VrTextcomponents>
                  VR
                </VrTextcomponents>
              </Col>
              <VrSearchcomponents>
                <Search
                  placeholder="ค้นหางานวิ่ง"
                  onSearch={value => console.log(value)}
                  // size="large"
                  style={{
                    width: '300px', borderRadius: '50px',
                  }}
                />
              </VrSearchcomponents>
            </VrRowcomponents>
          </Col>
          {/* <Col style={{ border: '1px solid rgba(153, 153, 153, 0.26)', width: '600px' }}/>  */}
          <Col style={{ textAlign: 'left' }}>
            <Tabs defaultActiveKey="1" onChange={callback} type="card">
              <TabPane tab="งานวิ่งที่ยังไม่ได้วิ่ง" key="1">
                <List
                  className="demo-loadmore-list"
                  loading={initLoading}
                  itemLayout="horizontal"
                  loadMore={loadMore}
                  dataSource={list}
                  renderItem={item => (
                    <List.Item
                      actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                    >
                      <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta
                          avatar={
                            <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                          }
                          title={<a href="https://ant.design">{item.name.last}</a>}
                          description="Ant Design, a design language for background applications, is refined by Ant UED Team"
                        />
                        <div>content</div>
                      </Skeleton>
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="งานวิ่งที่น่าสนใจ" key="2">
                Content of Tab Pane 2
              </TabPane>
              <TabPane tab="Finisherwall" key="3">
                Content of Tab Pane 3
              </TabPane>
            </Tabs>
          </Col>
        </VrHeadercomponents>
      </Vrcomponents>
    )
  }
}

export default ProfileContainer



// WEBPACK FOOTER //
// ./src/components/vr.js